import CouponListContainer from '../../../../Componant/Application/Ecommerce/master/CouponListContainer'

const CouponList = () => {
  return (
    <div className='page-body'>
      <CouponListContainer />
    </div>
  )
}

export default CouponList